import { Button, Text } from "@aurem/ui";
import ROUTES from "const/routes";
import { useI18n } from "providers/I18nProvider";
import type { FC } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import { PageLayout } from "../../../layouts/PageLayout";

export const NotFound: FC = () => {
  const navigate = useNavigate();
  const { language } = useParams();

  const { t } = useI18n();
  return (
    <PageLayout className="gap-8">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3 text-neutral-500">
          <Text weight="medium">
            {t("apps.admin.pages.notFound.page.error")}
          </Text>
          <h1 className="text-4xl font-medium">
            {t("apps.admin.pages.notFound.page.heading")}
          </h1>
        </div>
        <Text className="text-neutral-400">
          {t("apps.admin.pages.notFound.page.description")}
        </Text>
      </div>
      <div className="flex items-center gap-4">
        <Button variant="text" color="neutral" onClick={() => navigate(-1)}>
          {t("apps.admin.pages.notFound.page.back")}
        </Button>
        <Button
          as={Link}
          to={`/${language}/${ROUTES.ROOT}`}
          variant="text"
          color="neutral"
          className="underline"
        >
          {t("apps.admin.pages.notFound.page.companies")}
        </Button>
      </div>
    </PageLayout>
  );
};
